import { useEffect, useState } from 'react';

export const useTeams = () => {
	const [isValidating, setIsValidating] = useState(true);
	const [isTeams, setIsTeams] = useState(false);
	const [app, setApp] = useState(null);
	const [authentication, setAuthentication] = useState(null);

	useEffect(() => {
		const checkTeams = async () => {
			try {
				const { app, authentication } = await import('@microsoft/teams-js');
				await app.initialize();
				// @ts-expect-error
				setApp(app);
				// @ts-expect-error
				setAuthentication(authentication);
				setIsTeams(true);
				setIsValidating(false);
			} catch (e) {
				// eslint-disable-next-line no-console
				console.error('Error on TeamsAuthContext ' + e);
				setIsTeams(false);
				setIsValidating(false);
			}
		};
		checkTeams();
	}, []);

	return { isTeams, app, authentication, isValidating };
};
